import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Order} from '../../../domain/order';
import {MatSort, Sort} from '@angular/material/sort';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
  selector: 'app-order-table',
  templateUrl: './order-table.component.html',
  styleUrl: './order-table.component.css',
  standalone: false
})
export class OrderTableComponent implements AfterViewInit {
  dataSource: MatTableDataSource<Order>;

  displayedColumns = [];

  private _orders: Order[];

  @Input('orders')
  set orders(value: Order[]) {
    this._orders = value;

    this.buildColumnList();

    if (this.dataSource == null) {
      this.dataSource = new MatTableDataSource(this._orders);
    } else {
      this.dataSource.data = this._orders;
    }
  }

  _showAssignColumn: boolean;

  @Input('showAssignColumn')
  set showAssignColumn(value: boolean) {
    this._showAssignColumn = value;
    this.buildColumnList();
  }

  get showAssignColumn() {
    return this._showAssignColumn;
  }

  _multipleSelect: boolean;

  @Input('multipleSelect')
  set multipleSelect(value: boolean) {
    this._multipleSelect = value;
    this.buildColumnList();
  }

  get multipleSelect() {
    return this._multipleSelect;
  }

  @Output() assignOrder: EventEmitter<Order> = new EventEmitter<Order>();
  @Output() unassignOrder: EventEmitter<Order> = new EventEmitter<Order>();
  @Output() selectionToggled: EventEmitter<Order> = new EventEmitter<Order>();

  @Input() sortColumn: string;
  @Input() sortDirection: string;

  @Output() sortChanged: EventEmitter<any> = new EventEmitter();

  selectedOrders = new SelectionModel<Order>(true, null);

  @ViewChild(MatSort) sort: MatSort;

  private buildColumnList() {
    let columns = [
      'ExternalId',
      'CreatedAt',
      'UpdatedAt',
      'Status',
      'Carrier',
      'Username'
    ];

    if (this.showAssignColumn) {
      columns.push('Assign');
    }

    this.displayedColumns = columns;
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe((s: Sort) => {
      this.sortChanged.emit(s);
    });
  }

  protected selectOrder(order) {
    if (this.multipleSelect) {
      this.selectedOrders.toggle(order);
      this.selectionToggled.emit(order);
    } else {
      //this.router.navigate(['/admin/shipment', order.Number]);
    }
  }

  assign(order: Order, $event) {
    $event.stopPropagation();

    this.assignOrder.emit(order);
  }

  unassign(order: Order, $event) {
    $event.stopPropagation();

    this.unassignOrder.emit(order);
  }

  public clearSelection() {
    this.selectedOrders.clear();
  }
}
